import { Router } from '@angular/router';
import { AuthService } from '../providers/auth/auth.service';
import * as i0 from "@angular/core";
import * as i1 from "../providers/auth/auth.service";
import * as i2 from "@angular/router";
export class DashboardRedirectGuard {
    constructor(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    canActivate(route, state) {
        if (state.url.includes('/defect/')) {
            return true;
        }
        return this.authService.checkToken().then((value) => {
            if (!this.authService.authenticationState.getValue()) {
                return true;
            }
            let user = this.authService.user;
            if (!user) {
                user = this.authService.getUserProfile();
                if (!user) {
                    return true;
                }
            }
            if (!user || !user.extra_vars || !user.extra_vars.permissions) {
                return true;
            }
            const hasDepotKioskPermission = user.extra_vars.permissions.some((perm) => perm.PermissionName === 'Defect Depot Kiosk');
            if (hasDepotKioskPermission) {
                this.router.navigateByUrl('/dashboard-depot');
                return false;
            }
            return true;
        }).catch((error) => {
            console.log('DashboardRedirectGuard - error:', error);
            return true;
        });
    }
}
DashboardRedirectGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DashboardRedirectGuard_Factory() { return new DashboardRedirectGuard(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i2.Router)); }, token: DashboardRedirectGuard, providedIn: "root" });
